export const en = {
    table:{
        adjustTable: 'Adjust Table'
    }
}